import { Inject } from 'inversify-props'
import type { WebhookServiceAdapter } from './adapter'

export class TestarWebhookUseCase {
	@Inject('WebhookServiceAdapter')
	private webhookService!: WebhookServiceAdapter

	testar = async (id: string): Promise<void> =>
		await this.webhookService.testar(id)
}
